import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { StarIcon } from 'lucide-react'

import { AppsFooter } from './apps-footer'

export const Rating = ({
	defaultValue,
	className,
}: {
	defaultValue: number
	className?: string
}) => {
	return (
		<div className={cn('flex gap-x-0.5', className)}>
			{Array.from({ length: 5 }, (_, i) => {
				const diff = Math.max(Math.min(defaultValue - i, 1), 0)

				return (
					<div
						className='relative'
						key={i}
					>
						<div
							className='absolute overflow-hidden'
							style={{
								width: i < defaultValue ? `${100 * diff}%` : 0,
							}}
						>
							<StarIcon
								className='fill-primary stroke-primary'
								strokeWidth={0}
							/>
						</div>

						<StarIcon
							className='fill-muted/30 stroke-muted/30'
							strokeWidth={0}
						/>
					</div>
				)
			})}
		</div>
	)
}

export const RatingSection = () => {
	return (
		<div className='flex items-center gap-3 text-sm'>
			<Rating defaultValue={4.8} />

			<div className='font-bold'>4,8/5</div>

			<a
				href='https://www.google.com/maps/search/cocoon+space/@48.8665006,2.306261,13z?entry=ttu'
				rel='noreferrer'
				target='_blank'
				className='text-left text-xs leading-none text-slate-500'
			>
				+600 avis Google
			</a>
		</div>
	)
}

export const BaselineAndRating = () => {
	const { t } = useLingui()

	return (
		<div className='flex flex-col gap-6'>
			<div className='flex flex-col gap-2 leading-none'>
				<p className='text-primary text-[30px] font-bold'>cocoon space</p>
				<p>{t`Location de bureaux, salle de réunion à Paris, Lyon, La Défense`}</p>
				<RatingSection />
			</div>

			<AppsFooter />
		</div>
	)
}
